import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import { PatternFormat } from 'react-number-format';
import TextInput from './TextInput';
import { InputProps } from './props';

const ZipCodeInput = forwardRef(({ onChange, ...props }, ref) => {
  return (
    <PatternFormat
      valueIsNumericString
      getInputRef={ref}
      type={InputProps.type.TEXT}
      customInput={TextInput}
      placeholder="_____"
      format="#####"
      mask="_"
      onValueChange={(v) => onChange(v.value)}
      {...props}
    />
  );
});

ZipCodeInput.displayName = 'ZipCodeInput';

ZipCodeInput.propTypes = {
  onChange: PropTypes.func.isRequired,
};

export default ZipCodeInput;
